import script from "./CareerCompassModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CareerCompassModal.vue?vue&type=script&setup=true&lang=ts"

import "./CareerCompassModal.vue?vue&type=style&index=0&id=d9bc1c2e&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9bc1c2e"]])

export default __exports__